module.exports = __webpack_public_path__ + "static/media/main-stage-2-locked.08a23b1a.png";